import { Color } from "three";

/**
 * This is a little utility to help with adapting legacy three.js color
 * specifications to the LinearSRGBColorSpace. Accepts a hexedecimal number
 * (e.g. 0xFFFFFF) or a CSS color string, which three.js will interpret. If
 * `THREE.ColorManagement.enabled == false`, then the value is accepted as
 * linear and remains linear.
 */
export const gammaCorrect = (c: Color | number | string): Color => {
    const color = new Color(c); 
    color.r = Math.sqrt(color.r);
    color.g = Math.sqrt(color.g);
    color.b = Math.sqrt(color.b);
    return color;
}

export default gammaCorrect;
